import { render, staticRenderFns } from "./Ediciones.vue?vue&type=template&id=3d7e2506&"
import script from "./Ediciones.vue?vue&type=script&lang=js&"
export * from "./Ediciones.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports